import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PageHeaderText } from 'iovisit-museum-theme/components/Views';

import {
  PageMetadata,
  ViewBlocks,
  RelatedItems,
} from 'iovisit-theme/components/Views';

const messages = defineMessages({
  related_rooms: {
    id: 'related_rooms',
    defaultMessage: 'Visita le altre sale del museo',
  },
  related_items: {
    id: 'room_related_items',
    defaultMessage: 'Correlati in evidenza',
  },
});

const RoomView = ({ content, location }) => {
  const intl = useIntl();

  return (
    <div id="page-room" className="ui container">
      <PageHeaderText content={content} showDownloadApp={true} />

      <ViewBlocks content={content} location={location} />

      {/* Stanze correlate */}
      {content.related_rooms?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_rooms)}
          items={content.related_rooms}
          background={true}
        />
      )}

      {/* Items correlati */}
      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={(content.related_rooms || []).length === 0}
        />
      )}

      <PageMetadata content={content} />
    </div>
  );
};

export default RoomView;
